var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "table table-order table-order--cart",
      class: { "checkout-cart": _vm.checkOutCart == true }
    },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function(column) {
            return _c("th", { key: column }, [_vm._v(_vm._s(column))])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.cartItems, function(cartItem, index) {
        return _c(
          "tbody",
          {
            key: cartItem.id,
            staticClass: "plant-group cart-item",
            class: { even: index % 2 === 0, odd: index % 2 !== 0 }
          },
          [
            _c("order-table-cart-item-component", {
              attrs: { index: index, cartItem: cartItem }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      !_vm.cartItems.length
        ? _c("tbody", [
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: _vm.columns.length }
                },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Your cart is empty.")
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }